// extracted by mini-css-extract-plugin
export default {"title":"Login_title__ONT4I","login":"Login_login__QV+Qp"};